<template>
	<form class="form" @submit.prevent="submit" novalidate>
		<ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>

		<fieldset class="form__group">
			<legend>Assign to a company</legend>

			<div class="form__group">
				<div class="toggle-group">
					<input id="single" name="mandated" class="toggle"
					       type="radio" :value="false" v-model="formData.multiple" v-validate required />
					<label for="single" class="toggle">Single User</label>
					<input id="multiple" name="mandated" class="toggle"
					       type="radio" :value="true" v-model="formData.multiple" v-validate required />
					<label for="multiple" class="toggle">Multiple Users (CSV)</label>
				</div>
				<label class="form__label">Would you like to create a single user profile or upload multiple users?</label>
				<div class="form__validation">{{ errors.first('mandated') }}</div>
			</div>

			<FormControlMember label="Select a Company" placeholder="Select the company that the user works for..."
			                   v-model="formData.member" name="member" v-validate="'required'">
			</FormControlMember>

			<div class="form__group form__group--submit">
				<button class="btn btn--primary">Continue</button>
			</div>
		</fieldset>
	</form>
</template>

<script>
	import ValidationAlert from '../../ValidationAlert';
	import FormControlMember from '../../Form/Control/FormControlMember';
	import UserCreateFormStep from './UserCreateFormStep';

	export default {
		name: 'UserCreateFormStep1',
		components: {
			FormControlMember,
			ValidationAlert,
		},
		mixins: [UserCreateFormStep],
		data() {
			return {
				formData: {
					multiple: false,
					member: null,
				}
			}
		},
		methods: {
			//Don't need to send anything on this step
			save() {
				return Promise.resolve();
			}
		}
	}
</script>
